import { render } from "./Graph4.vue?vue&type=template&id=5abf881f&ts=true"
import script from "./Graph4.vue?vue&type=script&lang=ts"
export * from "./Graph4.vue?vue&type=script&lang=ts"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__